import React, { FC } from 'react'
import MainLayout from '@components/MainLayout/MainLayout'
import { strapiInstance } from '@utilities/axios/strapi'
import { MainObject } from '@components/BinStore/types'
import BinStore from '@components/BinStore/BinStore'

export const getServerSideProps = async () => {
  const { data } = await strapiInstance.get('/bin-store?populate=*')

  return {
    props: { ...data },
  }
}

const BinStorePage: FC<MainObject> = (props) => {
  return (
    <MainLayout previewImage="" hideOverflow={false}>
      <BinStore {...props} />
    </MainLayout>
  )
}

export default BinStorePage
